module.exports = __webpack_public_path__ + "img/tverrprofil.c23bf3e4.jpg";